import { render, staticRenderFns } from "./InviteNewMember.vue?vue&type=template&id=5f253aa0&scoped=true&"
import script from "./InviteNewMember.vue?vue&type=script&lang=js&"
export * from "./InviteNewMember.vue?vue&type=script&lang=js&"
import style0 from "./InviteNewMember.vue?vue&type=style&index=0&id=5f253aa0&prod&scoped=true&lang=scss&"
import style1 from "./InviteNewMember.vue?vue&type=style&index=1&id=5f253aa0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f253aa0",
  null
  
)

export default component.exports